import { useEffect, useState } from "react";

const COLORS = ["bg-blue-600", "bg-emerald-500", "bg-orange-500", "bg-rose-500", "bg-violet-600", "bg-cyan-600", "bg-amber-500", "bg-slate-600"];

export function VendorLogo({ vendor, size = "w-12 h-12", text = "text-lg" }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [vendor.id, vendor.logo_updated_at]);
  const name = vendor.name || "?";
  const color = COLORS[[...name].reduce((a, c) => a + c.charCodeAt(0), 0) % COLORS.length];

  if (vendor.has_logo && !failed) {
    return (
      <div className={`${size} rounded-lg bg-white border border-border flex items-center justify-center overflow-hidden shrink-0`}>
        <img
          src={`/api/vendors/${vendor.id}/logo?v=${encodeURIComponent(vendor.logo_updated_at || "")}`}
          alt={`${name} Logo`}
          className="w-full h-full object-contain p-1"
          onError={() => setFailed(true)}
          data-testid={`vendor-logo-img-${vendor.id}`}
        />
      </div>
    );
  }
  return (
    <div className={`${size} rounded-lg ${color} flex items-center justify-center text-white font-bold ${text} shrink-0`} data-testid={`vendor-logo-fallback-${vendor.id}`}>
      {name.charAt(0).toUpperCase()}
    </div>
  );
}
